import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const Container = styled.div`
  background-color: #0000c9;

  position: sticky;
  top: 0;
  z-index: 1000;
`;

export const Content = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  height: 1.813em;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: row-reverse;
    margin-right: 8px;
    a {
      margin-left: auto;
    }
  }
`;

export const ContentMenu = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding: 1em;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: row-reverse;
    a {
      margin-left: auto;
    }
  }
`;

export const ContentLogo = styled.div`
  @media (max-width: 768px) {
    width: 65%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const StyledMarcaSebrae = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 3px 4px;
  font-size: 11px;
  font-family: 'Lato', sans-serif;
  color: #fff;
  text-decoration: none;
  &::before {
    content: '';
    background: url(${({ iconMarca }) => iconMarca}) no-repeat center center;
    width: 12px;
    height: 8px;
    display: inline-block;
    margin-right: 4px;
  }

  transition: outline 0.3s ease;
  &:hover {
    outline: 1px solid #fff;
    border-radius: 2px;
    text-decoration: underline;
  }
`;

export const StyledImage = styled.img`
  transition: outline 0.3s ease;

  &:hover {
    outline: 1px solid #fff;
    border-radius: 2px;
  }
`;
export const ContentAcessibility = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  select {
    font-family: Lato, sans-serif;
    background: none;
    border: none;
    color: #fff;
  }
`;

export const Separator = styled.div`
  height: 1px;
  background-color: #ffffff80;
`;

export const MenuContainer = styled.ul`
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    background-color: #0000c9;
    position: fixed;
    top: 70px;
    left: 50px;
  }
`;

export const MenuItem = styled.ul`
  color: #fff;
  cursor: pointer;
  position: relative;

  &:hover {
    color: #ddd;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -22px;
    left: 0;
    right: 0;
    height: 5px;
    background-color: ${({ isActive }) => (isActive ? 'white' : 'transparent')};
    transition: background-color 0.3s ease;
  }

  @media (max-width: 768px) {
    padding: 10px 0;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    &::after {
      content: '';
      background-color: transparent;
    }
  }
`;
export const Hamburger = styled.div`
  display: none;
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
    padding: 10px;
    font-size: 20px;
    color: ${BaSeTheme.colors.defaultColors.white};
  }
`;

// Drawer
export const Drawer = styled.div`
  position: fixed;
  top: 108px;
  left: 0;
  height: 100%;
  width: 300px;
  background-color: #0000c9;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.3);
  transform: ${(props) =>
    props.isOpen ? 'translateX(0)' : 'translateX(-100%)'};
  transition: transform 0.3s ease-in-out;
  z-index: 1000;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

// Overlay
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
`;
